import styled from '@emotion/styled'

/** although the second line in the output readonly drawer looks thicker
 * than the other lines in Chrome, IE11 renders it perfectly fine. */

export default styled.hr(
  (props) => `
  margin: 20px -20px;
  border-bottom: 1px solid ${props.theme.navBorderBottomColor};
`
)
